var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69531 3.80933V7.05135H5.93733",
    stroke: "#8927EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05156 9.75293C4.40191 10.7474 5.06595 11.601 5.94363 12.1852C6.82131 12.7694 7.86508 13.0525 8.91768 12.992C9.97027 12.9314 10.9747 12.5304 11.7795 11.8493C12.5844 11.1683 13.1461 10.2441 13.3801 9.21603C13.614 8.18798 13.5075 7.11174 13.0766 6.14948C12.6457 5.18721 11.9137 4.39105 10.991 3.88096C10.0683 3.37087 9.00477 3.17447 7.96072 3.32136C6.91667 3.46825 5.94863 3.95048 5.20248 4.69537L2.69531 7.05124",
    stroke: "#8927EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.a0e98043b973dcd3fc8d3c5783996c63.svg";
export { ForwardRef as ReactComponent };